import { Component, Input } from '@angular/core';
import { SearchResult } from '../../../../api/models/search-result';
import { SearchTableSortingHeader } from '../../../../shared/model/search-table-sorting-header';
import { SearchResultEntry } from '../../../../api/models/search-result-entry';
import { DataCompletionService } from '../../../../api/services/data-completion.service';
import { SearchResultInstrumentDriver } from '../../../../shared/model/search-result-instrument-driver';
import { SearchEventPublisher } from '../../../../shared/service/search-event-publisher.service';
import { SearchEventTypeEnum } from '../../../../shared/model/search-event-type-enum';

@Component({
  selector: 'app-search-instrument-driver-table',
  templateUrl: './search-instrument-driver-table.component.html',
  styleUrls: ['./search-instrument-driver-table.component.scss'],
})
export class SearchInstrumentDriverTableComponent {
  @Input()
  searchResult?: SearchResult;

  @Input()
  tableHeaders?: SearchTableSortingHeader[];

  constructor(
    private dataCompletionService: DataCompletionService,
    private searchEventPublisher: SearchEventPublisher
  ) {}

  getSearchResultList(): SearchResultInstrumentDriver[] {
    return (this.searchResult?.searchResultList as SearchResultInstrumentDriver[]) || [];
  }

  sortTable(header: SearchTableSortingHeader) {
    if (header.params) {
      this.searchEventPublisher.publishEvent(SearchEventTypeEnum.SORT_RESULT, header.params);
    }
  }

  toggleDriverTable(searchResultEntry: SearchResultEntry) {
    const entry = searchResultEntry as SearchResultInstrumentDriver;
    const opened = !entry.driversTableOpened;
    if (opened && (!entry.dataCompletionResponse || entry.dataCompletionResponse?.error)) {
      entry.isLoading = true;
      this.dataCompletionService
        .getData({
          manufacturer: entry.manufacturer,
          model: entry.model,
        })
        .subscribe({
          next: response => {
            entry.dataCompletionResponse = response;
            entry.driversTableOpened = opened;
            entry.hasError = false;
            entry.isLoading = false;
          },
          error: err => {
            entry.driversTableOpened = opened;
            entry.hasError = true;
            entry.isLoading = false;
          },
        });
    } else {
      entry.driversTableOpened = opened;
    }
  }
}
